import { render } from "./ProdSubOptions.vue?vue&type=template&id=1ae7f9e0&ts=true"
import script from "./ProdSubOptions.vue?vue&type=script&lang=ts"
export * from "./ProdSubOptions.vue?vue&type=script&lang=ts"

import "./ProdSubOptions.vue?vue&type=style&index=0&id=1ae7f9e0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__